import { TextContentComponent } from '@myriadgenetics/mgh-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './index.scss';

type DescriptionListProps = {
  type: 'TEXT_CONTENT';
  compDef: TextContentComponent;
};

export const DescriptionList = (props: DescriptionListProps) => {
  const { t } = useTranslation();

  if (!props.compDef.data.contentKey) {
    return null;
  }

  return (
    <dl className="description-list">
      <dt className="text-large--semi-bold color-gray-600">{t(props.compDef.data.contentKey)}</dt>
      <dd className="text-large--regular color-gray-600">{t(props.compDef.data.contentKey + 'Description')}</dd>
    </dl>
  );
};

export default DescriptionList;
